module.exports = __webpack_public_path__ + "static/media/LogicWedge1_2_2.ffe0c792.png";